import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA8-0R1G1tEX_9c4GhQhhtN3OrkXyUKjmg",
  authDomain: "oliver-tracker.firebaseapp.com",
  projectId: "oliver-tracker",
  storageBucket: "oliver-tracker.firebasestorage.app",
  messagingSenderId: "1022142552608",
  appId: "1:1022142552608:web:e731e4a24a66066fa97a45"
};

export const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
export const storage = getStorage(app);
